import React, {useState} from 'react';
import S from 'StyledAccountBonus.js';
import {connect, batch} from 'react-redux';
import {bindActionCreators} from 'redux';
import {NavLink, withRouter} from 'react-router-dom';
import {translation} from 'helpers/utilsHelper.js';
import AccountBonusRoute from 'AccountBonusRoute.js';
import {formatDate} from 'datesHelper.js';
import {changeDateByType, changeActiveTab, fetchBonusListByFilter} from 'accountBonusActions.js';
import CmsPage from 'CmsPage.js';

const AccountBonus = (props) => {
    const {match, changeActiveTab, activeTab} = props;
    const [calendarStartDate, setCalendarStartDate] = useState(formatDate(new Date, 'yyyy-MM-dd'));
    const [calendarEndDate, setCalendarEndDate] = useState(formatDate(new Date, 'yyyy-MM-dd'));

    const handleChangeStart = (date) => {
        const {changeDateByType, fetchBonusListByFilter} = props;
        const startDate = new Date(date);

        setCalendarStartDate(date);

        batch(() => {
            changeDateByType('startDate', startDate);
            fetchBonusListByFilter();
        })
    };

    const handleChangeEnd = (date) => {
        const {changeDateByType, fetchBonusListByFilter} = props;
        const endDate = new Date(date);
        
        setCalendarEndDate(date);
        
        batch(() => {
            changeDateByType('endDate', endDate);
            fetchBonusListByFilter();
        })
    };

    return (
        <S.AccountBonus>
        <CmsPage name="bonus-mobile" isPlaces={true} />
        <S.BonusFilters className="bonus-filters">
            { activeTab !== "active" && (
                <S.BonusFiltersDates className="bonus-filters-dates">
                        <S.Datepicker>
                            <S.DateLabel>{translation('common_dateFrom')}</S.DateLabel>
                            <input type="date"
                                value={calendarStartDate}
                                onChange={(event) => handleChangeStart(event.target.value)}
                            />
                            <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
                        </S.Datepicker>
                        <S.Datepicker>
                            <S.DateLabel>{translation('common_dateTo')}</S.DateLabel>
                            <input type="date"
                                value={calendarEndDate}
                                onChange={(event) => handleChangeEnd(event.target.value)}
                            />
                            <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
                        </S.Datepicker>
                </S.BonusFiltersDates>
            )}
                    <S.BonusFiltersBtns className="bonus-btns-wrapper">
                        <S.FilterBtn as={NavLink} to={`${match.path}/active-bonus`} exact activeClassName="active"
                                     onClick={changeActiveTab.bind(null, 'active')}>{translation('account_bonus_active')}</S.FilterBtn>

                        <S.FilterBtn as={NavLink} to={`${match.path}/queue-bonus`} exact activeClassName="active"
                                    onClick={changeActiveTab.bind(null, 'queue')}>{translation('account_bonus_queue')}</S.FilterBtn>

                        <S.FilterBtn as={NavLink} to={`${match.path}/historical-bonus`} exact activeClassName="active"
                                     onClick={changeActiveTab.bind(null, 'history')}>{translation('account_bonus_history')}</S.FilterBtn>   
                    </S.BonusFiltersBtns>
        
        </S.BonusFilters>

        <AccountBonusRoute {...props}/>

    </S.AccountBonus>
    );
};

const mapStateToProps = ({AccountBonus:{startDate, endDate, activeTab, limit}}, props) => {
    return {
        startDate,
        endDate,
        activeTab,
        limit
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeDateByType: bindActionCreators(changeDateByType, dispatch),
        changeActiveTab: bindActionCreators(changeActiveTab, dispatch),
        fetchBonusListByFilter: bindActionCreators(fetchBonusListByFilter, dispatch),
        dispatch
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountBonus));